import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ShareFeedbackButtonLoader: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LazyFeedbackCollector" */ './ShareFeedbackButton.tsx'
			)
		).ShareFeedbackButton,
});
